import { Route, Routes } from 'react-router-dom';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { hasAccessRight } from '../../utils/Functions';
import { ModashInfo } from './components/ModashInfo';

export function ModashRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.MODASH_CHECK) && (
                <>
                    <Route index element={<ModashInfo />} />
                </>
            )}
        </Routes>
    );
}
